/**
 * The title row every page starts with: back button, title, optional subtitle beneath the title text and
 * actions on the right. One place for the gap and the spacing, so titles line up from page to page.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import BackButton from 'components/common/buttons/BackButton';

// Back button 40px + 8px gap: the subtitle starts under the title text.
const INDENT = '48px';

// Tabs placed in the title row (as children), the same on every page: the Collaboration Hub's look.
export const HEADER_TABS_SX = {
  ml: 2, minHeight: 40, alignSelf: 'stretch',
  '& .MuiTabs-flexContainer': { height: '100%' },
  '& .MuiTab-root': { minHeight: 40, py: 1, px: 1.5 },
};

export default function PageHeader({ title, subtitle, actions, back = true, children, sx }) {
  return (
    <Box sx={{ mb: .5, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: 40 }}>
        {back && <BackButton position="inline" sx={{ flexShrink: 0, width: 40, height: 40 }} />}
        <Typography variant="h4" fontWeight={800} sx={{ letterSpacing: 0.2, lineHeight: 1.25, whiteSpace: 'nowrap', flexShrink: 0 }}>{title}</Typography>
        {children}
        {actions && <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>{actions}</Box>}
      </Box>
      {/* {subtitle && (
        <Typography sx={{ fontSize: 13, color: 'text.secondary', pl: back ? INDENT : 0, lineHeight: 1, mt: -0.5 }}>{subtitle}</Typography>
      )} */}
    </Box>
  );
}
